import React from "react";
import clsx from "clsx";
import PackageIcon from "components/PackageIcon/PackageIcon";
import { BackgroundColor } from "types/componentBackground";
import * as styles from "./OfferHighlightCard.module.scss";
import { OfferHighlight } from "./OfferHighlights";
import { BlockContent } from "components/BlockContent";
import type { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import { match, P } from "ts-pattern";

interface OfferHighlightCardProps {
  offer: OfferHighlight;
  tokenValues: TokenValues;
  backgroundColor: BackgroundColor;
  defaultOfferIconUrl: string | undefined;
}

const OfferHighlightCard: React.FC<
  React.PropsWithChildren<OfferHighlightCardProps>
> = ({ offer, tokenValues, backgroundColor, defaultOfferIconUrl }) => {
  const icon = match<[string | undefined, string | undefined]>([
    offer.icon,
    defaultOfferIconUrl || offer.iconUrl
  ])
    .with(["default", P.string], [P.nullish, P.string], ([_, url]) => (
      <img src={url} alt="icon" loading="lazy" className={styles.iconUrl} />
    ))
    .with([P.string, P.any], ([i]) => <PackageIcon icon={i} />)
    .otherwise(() => null);

  return (
    <div
      className={clsx(styles.offer, {
        [styles.backgroundNeutral05]: backgroundColor == "neutral05",
        [styles.backgroundWhite]: backgroundColor == "white"
      })}
    >
      {icon}
      <div className={styles.title}>
        <BlockContent value={offer.name} tokens={tokenValues} />
      </div>
      <div className={styles.content}>
        <BlockContent value={offer.description} tokens={tokenValues} />
      </div>
    </div>
  );
};

export default OfferHighlightCard;
